import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { IGigDayExtended } from 'models/GigDay'

export const GetGigDays = action('GetGigDays', payload<IPayload<IGigDayExtended[]>>())
export const GetGigDaysErrors = action('GetGigDaysErrors', payload<IError>())
export const GigDaysFetching = action('GigDaysFetching', payload<boolean>())
